import { api } from './api';

const tokenPublicStaging = 'Basic NjgwOTI4NjMyMzI3Zjc0ZjNhMzZmNjEyOjYzNGQyN2QwOTI3MWYzMzdiMzlmMTQ1OQ==';
const tokenPublicProd = 'Basic NjgwOTI4NjMyMzI3Zjc0ZjNhMzZmNjEyOjYzNGQyN2QwOTI3MWYzMzdiMzlmMTQ1OQ==';

export async function getFaq(cycle?: string, rede?: boolean): Promise<any[]> {
  const payload: any = [
    {
      $project: {
        _id: 1,
        order: 1,
        title: 1,
      },
    },
    {
      $sort: {
        order: 1,
      },
    },
  ];

  if (cycle) {
    payload.unshift({
      $match: {
        cycle,
      },
    });
  }

  try {
    const { data } = await api.post(`database/${rede ? 'faq_rede__c' : 'faq__c'}/aggregate`, payload, {
      headers: {
        Authorization: !!window.location.href.match(/(funifier\.app|netlify\.app|localhost)/gi)
          ? tokenPublicStaging
          : tokenPublicProd,
      },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getFaqContent(_id: string, rede?: boolean): Promise<string> {
  try {
    const { data } = await api.post(
      `database/${rede ? 'faq_rede__c' : 'faq__c'}/aggregate`,
      [
        {
          $match: {
            _id,
          },
        },
        {
          $project: {
            _id: 0,
            content: 1,
          },
        },
      ],
      {
        headers: {
          Authorization: !!window.location.href.match(/(funifier\.app|netlify\.app|localhost)/gi)
            ? tokenPublicStaging
            : tokenPublicProd,
        },
      },
    );

    if (!Array.isArray(data)) {
      return '';
    } else {
      return data.length ? data[0].content : '';
    }
  } catch (e) {
    throw e;
  }
}
